// @flow
import * as React from 'react';
import { Box, Stack, Text } from 'grommet';
import ReactTooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import { AVATAR_BORDER_RADIUS } from 'esm-web-pro/styles/theme';
import { userBadgeBorderStyle } from 'esm-web-pro/components/UserBadge';

export type User = {
    first_name: ?string,
    last_name: ?string,
    username: string,
};


const margin = { left: 'xsmall' };
const stackMargin = { top: '-4px' };

type Props = {
    user: User,
    active?: boolean,
    action: string,
};

export const getInitialsFromUsername = (username: string) => {
    if (username) {
        if (username.startsWith('Анонимен')) {
            return 'A';
        }
        const splitName = username.split(' ');
        if (splitName.length === 2 && splitName.every((name) => name.length > 0)) {
            // eslint-disable-next-line max-len
            return `${splitName[0][0].toUpperCase()}${splitName[1][0].toUpperCase()}`;
        }

        return username.substring(0, 2).toUpperCase();
    }
    return '';
};

const getUserText = (user) => {
    let userText = '';

    if (user.first_name?.startsWith('Анонимен')) {
        userText = 'A';
        return userText;
    }

    if (user) {
        userText = `${
            user.first_name ? user.first_name.charAt(0) : ''
        }${
            user.last_name ? user.last_name.charAt(0) : ''
        }`;
        if (!userText) {
            userText = getInitialsFromUsername(user.username);
        }
        userText = userText.toUpperCase();
    }

    return userText;
};

const MapUser = (props: Props) => {
    const { user, active, action } = props;

    const getTooltipValues = React.useCallback(() => ({
        username: user.username,
        active: (active === undefined || active) ? (
            <FormattedMessage id="active-session" defaultMessage="active" />
        ) : (
            <FormattedMessage id="inactive-session" defaultMessage="inactive" />
        ),
        action,
    }), [user, active, action]);

    return user ? (
        <Stack anchor="top-right">
            {user.avatar ? (
                <Box
                    data-tip
                    data-for={`${user.username}-map-user`}
                    align="center"
                    justify="center"
                    overflow="hidden"
                    round={{ size: AVATAR_BORDER_RADIUS }}
                    width="32px"
                    height="32px"
                    margin={margin}
                >
                    <img
                        src={user.avatar}
                        alt="event-user"
                        className="vertical-timeline-element--audit-event--avatar"
                    />
                </Box>
            ) : (
                <Box
                    data-tip
                    data-for={`${user.username}-map-user`}
                    width="32px"
                    height="32px"
                    align="center"
                    justify="center"
                    margin={margin}
                    pad="xsmall"
                    border={userBadgeBorderStyle}
                    round={{ size: AVATAR_BORDER_RADIUS }}
                >
                    <Text size="medium">
                        {getUserText(user)}
                    </Text>
                </Box>
            )}
            {(active !== undefined) && (
                <Box
                    background={active ? 'status-ok' : 'status-error'}
                    pad="xsmall"
                    round
                    margin={stackMargin}
                />
            )}
            <ReactTooltip
                id={`${user.username}-map-user`}
                effect="solid"
                place="top"
                className="react-tooltip"
            >
                <Text size="small">
                    <FormattedMessage
                        id="map-user-tooltip"
                        defaultMessage="{username} has a {active} session for {action}"
                        values={getTooltipValues()}
                    />
                </Text>
            </ReactTooltip>
        </Stack>
    ) : null;
};

MapUser.defaultProps = {
    active: undefined,
};

export default MapUser;
